import { render, staticRenderFns } from "./UserActivityHistory.vue?vue&type=template&id=0d79ad5b&scoped=true"
import script from "./UserActivityHistory.vue?vue&type=script&lang=js"
export * from "./UserActivityHistory.vue?vue&type=script&lang=js"
import style0 from "./UserActivityHistory.vue?vue&type=style&index=0&id=0d79ad5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d79ad5b",
  null
  
)

export default component.exports